// src/components/ZezeSection.js
import React, { useRef } from 'react';
import './ZezeSection.css';
import zezeLogo from '../assets/zeze.jpeg';
import img1 from '../assets/z1.jpg';
import img2 from '../assets/z2.jpg';
import img3 from '../assets/z3.jpg';
import img4 from '../assets/z4.jpeg';
import img5 from '../assets/z5.jpeg';
import img6 from '../assets/z6.jpeg';
import img7 from '../assets/z7.jpeg';
import img8 from '../assets/z8.jpeg';
import img9 from '../assets/z9.jpeg';
import img11 from '../assets/z11.jpeg';
import img12 from '../assets/z12.jpeg';
import img13 from '../assets/z13.jpeg';
import img14 from '../assets/z14.jpeg';
import img15 from '../assets/z15.jpeg';
import img16 from '../assets/z16.jpeg';


export default function ZezeSection() {
  const sliderRef = useRef(null);
  const images = [img1, img2, img3, img4, img5, img6, img7, img8, img9, img11, img12, img13, img14, img15, img16];

  const scroll = (offset) => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: offset, behavior: 'smooth' });
    }
  };

  return (
    <section id="zeze-section" className="zeze-section">
      <div className="zeze-container">
        <h2>Zeze’nin Bahçesi</h2>
        <img src={zezeLogo} alt="Zeze’nin Bahçesi Logo" className="zeze-logo" />
        <blockquote className="zeze-quote">
          “Çocukların doğa ile tanıştırılması yaşamlarındaki en önemli olaylardan biri olarak görülmelidir.”
          <footer>— Thomas BERRY</footer>
        </blockquote>

        <div className="zeze-content">
          <p>
            Zeze’nin Bahçesi 2020 yılında pandemi koşullarında çocukların günlük ve sosyal hayatlarını
            daha mutlu ve bütünlüklü geçirebilmesi için bir grup öğretmen, çocuk gelişimi uzmanı,
            mimar ve sanatçının bir araya gelmesi ile Eymir’de kurulmuştur.
          </p>
          <p>
            Zeze’nin Bahçesi çocuğu merkeze alan, çocuk hakları ve çevre hakları temelli hareket eden bir
            oluşumdur. Tüm çalışmalarını ve programını hak temelli bir perspektifle doğada yapmayı hedefler.
          </p>
          <p>
            Çocukların doğada ve doğa temelli bir öğrenme deneyimi kazanmalarını önemser; bunun için
            etkinlikler üretir ve uygular.
          </p>
          <p>
            Çocukları, bitkileri, hayvanları, toprağı, havayı, suyu yani çevreyi bir bütün olarak görüp
            korumayı amaçlar. Bu amaç doğrultusunda çocuklara ve yetişkinlere fırsatlar sunar.
          </p>
          <p>
            Çocuğun öğrenme ve eğlenme hakkını aynı anda sağlamak için doğal malzemelerle tasarlanmış
            yapılandırılmış ve yarı yapılandırılmış özgün bir alandan oluşur.
          </p>
          <p>
            Uluslararası standartlara bağlı kalarak doğada öğrenme ve sınıf dışı eğitimi teşvik etmek ve
            özellikle Ankara’da yaygınlaştırmak amacı taşıyan her kurum, platform ve kişilerle işbirliğine
            ve ortaklığa açıktır.
          </p>
        </div>

        <h3>Hedefimiz;</h3>
        <ol className="principles-list">
          <li>Açık Alanda Olmak &amp; Sürekliliğini Sağlamak</li>
          <li>Çocuk ve Hak Temelli Bir Program Geliştirmek &amp; Uygulamak</li>
          <li>Merak &amp; Keşif &amp; Oyun Temelli Bir Model Uygulamak</li>
          <li>Çocukların Bütünsel Gelişimini Desteklemek</li>
          <li>Çocukların Tüm Duyu Organlarını Kullanmasına Katkı Sağlamak</li>
          <li>Faydalı Riskleri Gözetmek</li>
          <li>Çocuk &amp; Ebeveyn &amp; Zeze’nin Bahçesi Arasında İşbirliği Kurmak</li>
          <li>Çocuk–Kolaylaştırıcı Dengesi İle Hareket Etme</li>
        </ol>
      </div>

      <div className="image-slider-wrapper">
        <button className="slider-btn left" aria-label="Önceki" onClick={() => scroll(-300)}>‹</button>
        <div className="image-slider" ref={sliderRef}>
          {images.map((src, idx) => (
            <div key={idx} className="slider-item">
              <img src={src} alt={`Zeze etkinlik ${idx + 1}`} />
            </div>
          ))}
        </div>
        <button className="slider-btn right" aria-label="Sonraki" onClick={() => scroll(300)}>›</button>
      </div>

      <div className="zeze-contact-card">
        <h3>ZEZE’nin Bahçesi – Eymir</h3>
        <p><strong>Adres:</strong> Kümeevler Cad. No:364, Eymir, 06540 Gölbaşı/Ankara</p>
        <p><strong>Telefon:</strong> <a href="tel:+905498303732">0549 830 37 32</a></p>
        <p><strong>E‑posta:</strong> <a href="mailto:yeldegirmeni.ilkokulu@gmail.com">yeldegirmeni.ilkokulu@gmail.com</a></p>
        <div className="zeze-map">
          <iframe
            src="https://maps.google.com/maps?q=39.8015,32.8190&z=15&output=embed"
            allowFullScreen
            loading="lazy"
            title="Harita: Zeze’nin Bahçesi"
          />
        </div>
      </div>
    </section>
);
}
